import { useSearchParams, Link } from 'react-router-dom'
import { useLogout } from '../api/useAuth'
import { useAuthStore } from '../store/authStore'
import { useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'

export default function Frozen() {
  const [params] = useSearchParams()
  const reason = params.get('reason') || ''
  const { mutate: logoutMutate } = useLogout()
  const logout = useAuthStore((s) => s.logout)
  const navigate = useNavigate()

  const handleLogout = () => {
    logoutMutate(undefined, {
      onSuccess: () => {
        logout()
        navigate('/login')
      },
      onError: () => {
        logout()
        navigate('/login')
      },
    })
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-canvas px-4">
      <div className="max-w-md w-full text-center">
        <div className="text-6xl mb-6">🧊</div>
        <h1 className="text-2xl font-bold mb-3 text-fg">Аккаунт заморожен</h1>
        <p className="text-muted mb-4 leading-relaxed">
          Доступ к вашему аккаунту временно ограничен администрацией сайта.
        </p>
        {reason && (
          <div className="mb-6 p-4 rounded-xl bg-surface border border-line text-left">
            <p className="text-xs font-semibold text-muted mb-1">Причина</p>
            <p className="text-sm text-fg">{reason}</p>
          </div>
        )}
        <div className="p-4 rounded-xl bg-surface border border-line text-left mb-6">
          <p className="text-xs font-semibold text-muted mb-2">Что делать</p>
          <ul className="text-sm text-fg space-y-1">
            <li>• Ознакомьтесь с правилами сайта</li>
            <li>• Если вы считаете, что заморозка ошибочна — свяжитесь с поддержкой</li>
            <li>• После рассмотрения аккаунт будет разморожен</li>
          </ul>
        </div>
        <div className="flex flex-col gap-3">
          <Link
            to="/support"
            className="w-full py-2.5 rounded-xl text-sm font-bold bg-accent text-on-accent hover:opacity-90 transition-opacity"
          >
            Написать в поддержку
          </Link>
          <button
            onClick={handleLogout}
            className="w-full py-2.5 rounded-xl text-sm font-semibold border border-line text-muted hover:text-fg hover:border-fg transition-colors"
          >
            Выйти из аккаунта
          </button>
        </div>
      </div>
    </div>
  )
}
